var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
// tslint:disable:member-ordering
import { CustomElement, Component, Prop, State, Watch, COMPONENT_STATE, Event, html, classMap, styleMap, unsafeHTML, nothing } from '@sick-davinci/ce-decorators';
import { style } from './DropDown.style';
import { Option } from '../option/Option';
import { OptionGroup } from '../option/OptionGroup';
import { icon_expand_more } from '@sick-davinci/material-icons/navigation/expand_more.icon';
import { Spinner } from './../spinner/Spinner';
import { IconRef } from '../icon/IconRef';
import { ViewportSpaceAround } from '../_utils/SpaceAround';
/**
 * DropDownOption instance
 */

/**
 * Renderer which renders strings as html (via innerHTML)
 *
 * @param _value
 * @param label
 */
export const unsafeHTMLRenderer = (_value, label) => html`${unsafeHTML(label)}`;
/**
 * Default renderer for dropdown data
 * @param value
 * @param label
 */

export const defaultContentRenderer = (value, label) => html`<span>${label ? label : value}</span>`;
/**
 * A `davinci-drop-down` is a simple dropdown list and combo-box.
 * If used as a combo-box (editable), the content of the text-field displays the value instead of the selection.
 *
 * @example
 * ```html
 * <davinci-drop-down>
 *   <davinci-option value="1">One</davinci-option>
 *   <davinci-option value="2">Two</davinci-option>
 *   <davinci-option value="3">Three</davinci-option>
 * </davinci-drop-down>
 *  ```
 *
 * @additionalDescription
 * ## Known Issues
 * If you are using Angular and forms defer the .data call in a `window.setTimeout`
 *
 *  ## ES5 specific imports for using the contentRenderer
 *  If you need the ES5 version you have to import the template-tag html method from the dist/bundle.js
 *  ```typescript
 *  import { html } from '@sick-davinci/basic-elements/dist/bundle.js'
 *
 *  const element = document.createElement('davinci-drop-down')
 *  element.contentRenderer = (value, label) => html`label: ${label} value: ${value}`;
 *  ```
 *
 *  ### ES5 contentRenderer and Angular
 *  In Angular you can assign the function within a template
 *
 *  template:
 *  ```html
 *  <davinci-drop-down [contentRenderer]="renderer"></davinci-drop-down>
 *  ```
 *  component:
 *  ```typescript
 *  import { html } from '@sick-davinci/basic-elements/dist/bundle.js'
 *
 *  export class Component
 *  contentRenderer(value, label) {
 *      return html`label: ${label} value: ${value}`;
 *  }
 *
 * ## General Usage
 * ### Styling
 * The components styles can be overwritten to a certain degree (in general everything that is not specified in the components or sub-components :host styling
 *
 * The components width is set to max-content - meaning, it will grow in width to fit the selected value. This behavior can be overwritten by specifying the width manually via css
 *  ```
 *
 * @slot { davinci-option[] | option[] } `davinci-option` elements to define the dataset for the dropdown
 * @slot { davinci-option-group[] | optgroup[] } `davinci-option-group` elements to define a grouped dataset for the dropdown
 */

export let DropDown = (_dec = Component({
  tag: 'davinci-drop-down',
  style: [style],
  dependencies: [Option, OptionGroup, Spinner, IconRef]
}), _dec2 = Reflect.metadata("design:paramtypes", []), _dec3 = Prop(), _dec4 = Reflect.metadata("design:type", String), _dec5 = Prop(), _dec6 = Reflect.metadata("design:type", String), _dec7 = Prop(), _dec8 = Reflect.metadata("design:type", Boolean), _dec9 = Prop(), _dec10 = Reflect.metadata("design:type", Boolean), _dec11 = Prop(), _dec12 = Reflect.metadata("design:type", Boolean), _dec13 = Prop(), _dec14 = Reflect.metadata("design:type", String), _dec15 = Prop({
  reflectAsAttribute: false
}), _dec16 = Reflect.metadata("design:type", String), _dec17 = Prop(), _dec18 = Reflect.metadata("design:type", Boolean), _dec19 = Prop(), _dec20 = Reflect.metadata("design:type", Boolean), _dec21 = Prop(), _dec22 = Reflect.metadata("design:type", Boolean), _dec23 = Prop({
  reflectAsAttribute: false,
  type: Object
}), _dec24 = Reflect.metadata("design:type", Object), _dec25 = Prop({
  reflectAsAttribute: false
}), _dec26 = Reflect.metadata("design:type", String), _dec27 = Prop(), _dec28 = Reflect.metadata("design:type", Boolean), _dec29 = Prop({
  reflectAsAttribute: false
}), _dec30 = Reflect.metadata("design:type", Function), _dec31 = State(), _dec32 = Reflect.metadata("design:type", Boolean), _dec33 = Event('change'), _dec34 = Reflect.metadata("design:type", Object), _dec35 = Event('input'), _dec36 = Reflect.metadata("design:type", Object), _dec37 = Watch('editable'), _dec38 = Reflect.metadata("design:paramtypes", [Boolean, Boolean]), _dec39 = Watch('disabled'), _dec40 = Reflect.metadata("design:paramtypes", [Boolean, Boolean]), _dec41 = Watch('expanded'), _dec42 = Reflect.metadata("design:paramtypes", [Boolean, Boolean]), _dec(_class = _dec2(_class = (_class2 = class DropDown extends CustomElement {
  /**
   * Identifier for supporting forms. Reserved for future usage.
   */

  /**
   * Specifies a short hint that describes the expected value. Displayed only in case the value is empty.
   */

  /**
   * Specifies if the dropdown list is editable and becomes a combo box.
   */

  /**
   * Specifies that the dropdown should be disabled.
   */

  /**
   * Specifies displaying the loading indicator.
   */

  /**
   * Specifies the label on top of the input field.
   */

  /**
   * Specifies the icon in front of the drop-down's content
   */

  /**
   * Sets the border to error color.
   */

  /**
   * Sets the border to warning color.
   */

  /**
   * lets the list exceed the dropdown width
   */

  /**
   * This variable holds the latest in `set data` created callback for promise resolution
   * this will ensure only the last promise of multiple promsies which are set in `set data` is resolved and populates data
   * ```
   * this.myDropdown.data = new Promise() // this will be discarded
   * this.myDropdown.data = new AnotherPromise() // this will populate the data property
   * ```
   */

  /**
   * Specifies the drop-down content.
   */
  set data(value) {
    if (value instanceof Promise) {
      Promise.resolve().then(() => {
        // must be deffered to microtask due to DAVIDC-34
        if (this._latestCallback) {
          // if latest callback not already resolved, show loading
          this.loading = true;
        }
      });

      const callback = promiseValue => {
        this.data = this._convertValuePropertyOfData(promiseValue); // [DAVIBE-405] [DAVIBE-402] convert numbers to string to allow number values
      }; // create a callback in the current closure execution scope which will run once the promise is resolved


      this._latestCallback = callback; // save the callback function which will be invoked for the current promise

      value.then(nonPromiseValue => {
        if (callback === this._latestCallback) {
          // populate the data of the dropdown only if this this is the resolution of the latest set promise
          callback(nonPromiseValue);
          this._latestCallback = null;
          this.loading = false;
        }
      });
    } else {
      this.internalData = this._convertValuePropertyOfData(value); // [DAVIBE-405] [DAVIBE-402] convert numbers to string to allow number values

      if (!!value) {
        this.internalDataFlat = this._flatData(value);
      } else {
        this.internalDataFlat = [];
      }
    }
  }

  get data() {
    return this.internalData;
  }
  /**
   * Get or set the value.
   */


  set value(value) {
    typeof value === 'number' ? this.internalValue = value.toString() : this.internalValue = value;
  }

  get value() {
    if (this.editable) {
      return this.internalValue ? this.internalValue : '';
    }

    const selectedOption = this.selectedDataEntry;
    return selectedOption ? selectedOption.value : undefined;
  }
  /**
   * Specifies if the dropdown list is expanded.
   */


  // ToDo @6.0.0 -> change to method getSelectionOption()
  get selectedDataEntry() {
    if (this.internalValue !== undefined && this.internalDataFlat) {
      return this.internalDataFlat.find(value => this.internalValue === value.value);
    } else {
      return undefined;
    }
  }

  _flatData(data) {
    const arr = data.map(entry => {
      if (typeof entry === 'string') {
        return {
          value: entry,
          label: entry
        };
      } else if ('data' in entry) {
        // we are in an Option group
        return this._flatData(entry.data);
      } else {
        entry.value = entry.value !== undefined ? entry.value : entry.label;
        return entry;
      }
    });
    return [].concat.apply([], arr); //tslint:disable-line
  }
  /**
   * Convert datatype of value property to string if it`s from type number [DAVIBE-405] [DAVIBE-402].
   */


  _convertValuePropertyOfData(value) {
    if (value) {
      value.map(entry => {
        if (typeof entry === 'object') {
          if ('value' in entry && typeof entry.value === 'number') {
            entry.value = entry.value.toString();
          } else if ('data' in entry && typeof entry.data === 'object') {
            if (entry.data) {
              entry.data.map(dataEntry => {
                if (typeof dataEntry === 'object' && 'value' in dataEntry && typeof dataEntry.value === 'number') {
                  dataEntry.value = dataEntry.value.toString();
                }
              });
            }
          }
        }
      });
      return value;
    } else {
      return undefined;
    }
  }

  /**
   * Eventhandler for focus-event on the Host
   * Delegates focus to input & makes Host untabbable
   */
  onFocus() {
    if (!this.shadowRoot) {
      window.requestAnimationFrame(this._onFocusCallback);
      return;
    }

    if (!this._focusedByMouse) {
      this.classList.add('focus-visible');
    }

    this.shadowRoot.querySelector('input').focus();
    this.tabIndex = -1;
  }
  /**
   * Eventhandler for blur-event on the Host
   * Makes Host tabbable again
   */


  onBlur() {
    if (!this.disabled) {
      this.tabIndex = 0;
    }

    this.classList.remove('focus-visible');
    this._focusedByMouse = false;
    this.expanded = false;
  }

  constructor() {
    super();

    _initializerDefineProperty(this, "name", _descriptor, this);

    _initializerDefineProperty(this, "placeholder", _descriptor2, this);

    _initializerDefineProperty(this, "editable", _descriptor3, this);

    _initializerDefineProperty(this, "disabled", _descriptor4, this);

    _initializerDefineProperty(this, "loading", _descriptor5, this);

    _initializerDefineProperty(this, "label", _descriptor6, this);

    _initializerDefineProperty(this, "iconSrc", _descriptor7, this);

    _initializerDefineProperty(this, "error", _descriptor8, this);

    _initializerDefineProperty(this, "warning", _descriptor9, this);

    _initializerDefineProperty(this, "wideList", _descriptor10, this);

    _defineProperty(this, "_latestCallback", null);

    _initializerDefineProperty(this, "expanded", _descriptor11, this);

    _initializerDefineProperty(this, "contentRenderer", _descriptor12, this);

    _initializerDefineProperty(this, "showPlaceholder", _descriptor13, this);

    _initializerDefineProperty(this, "change", _descriptor14, this);

    _initializerDefineProperty(this, "input", _descriptor15, this);

    _defineProperty(this, "internalValue", undefined);

    _defineProperty(this, "internalData", undefined);

    _defineProperty(this, "internalDataFlat", undefined);

    _defineProperty(this, "_focusedByMouse", false);

    _defineProperty(this, "clickListener", () => {
      this.expanded = false;
      window.removeEventListener('click', this.clickListener);
    });

    _defineProperty(this, "icon", icon_expand_more);

    _defineProperty(this, "listStyle", {
      'top': '0px',
      'max-height': '300px'
    });

    _defineProperty(this, "_highlightedOption", null);

    _defineProperty(this, "_currentAnimationFrame", null);

    _defineProperty(this, "_listElement", null);

    _defineProperty(this, "_mutationObserver", new MutationObserver(records => this.extractDataFromLightDom(records, false)));

    _defineProperty(this, "_mutationObeserverParent", this);

    _defineProperty(this, "_onFocusCallback", () => this.onFocus());

    _defineProperty(this, "_onBlurCallback", () => this.onBlur());

    _defineProperty(this, "onInputInputCallback", e => this.onInputInput(e));

    _defineProperty(this, "onInputChangeCallback", event => this.onInputChange(event));

    _defineProperty(this, "onKeyCaptureCallback", event => this.onKeyCapture(event));

    _defineProperty(this, "onOptionGroupClicked", event => {
      // Do nothing when clicked on an option group entry
      event.preventDefault();
      event.stopPropagation();
    });

    _defineProperty(this, "onOptionClicked", event => {
      const option = event.currentTarget;

      if (option.disabled) {
        return;
      }

      window.removeEventListener('click', this.clickListener);
      event.preventDefault();
      event.stopPropagation();
      this.selectOption(option);
    });

    _defineProperty(this, "onOptionMouseEnter", event => {
      event.preventDefault();
      event.stopPropagation();
      this.highlightOption(event.currentTarget);
    });

    _defineProperty(this, "onOptionMouseLeave", event => {
      event.preventDefault();
      event.stopPropagation();
      this.highlightOption();
    });

    _defineProperty(this, "onOptionMouseMove", event => {
      this.highlightOption(event.currentTarget); // remove this listener itself from all options, as mouseenter handler will do the work from now on more efficiently.

      this._getOptions().forEach(option => {
        option.removeEventListener('mousemove', this.onOptionMouseMove);
      });
    });

    _defineProperty(this, "stopEventPropagation", event => {
      event.stopPropagation();
      event.preventDefault();
    });

    _defineProperty(this, "onInputKeyDown", event => {
      if (event.key === 'Enter' && !this._highlightedOption) {
        event.stopPropagation();

        if (this.value !== this.internalValue) {
          this.value = event.currentTarget.value;
        }

        this.change.emit(this.internalValue);
        this.expanded = false;
      }
    });

    _defineProperty(this, "onMouseDown", () => {
      this._focusedByMouse = true;
    });

    _defineProperty(this, "onClickCapture", event => {
      if (event.currentTarget.className.indexOf('overlaywrapper') >= 0) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (event.target.tagName === 'INPUT') {
        this.expanded = true;
      } else {
        this.expanded = !this.expanded;
      }
    });

    _defineProperty(this, "expandOrMoveHighlight", (event, direction) => {
      event.preventDefault();

      if (!this._highlightedOption) {
        this.highlightOption(this._getSelectedOption());
      }

      this.expanded ? this.moveHighlight(direction) : this.expanded = true;
    });

    _defineProperty(this, "_calculateListDimensions", () => {
      var _this$shadowRoot$quer;

      // recalculate until this._currentAnimationFrame is canceled (see @Watch('expanded'))
      this._currentAnimationFrame = window.requestAnimationFrame(this._calculateListDimensions);

      if (this.shadowRoot === null || this.shadowRoot === undefined) {
        return; // return early if not rendered
      }

      const {
        top,
        height,
        left,
        width
      } = this.getBoundingClientRect(); // on android, iphone and i pad document.document.clientElement.clientWidth/Height pretends the url bar is always visible even when hidden and report a wrong value
      // on desktop browsers window.innerWidth/Height also includes the scollbars and we have to subtract them thus using document.documentElement.clientHeight
      // https://stackoverflow.com/questions/14388367/mobile-safari-window-height-url-bar-discrepancy
      // does not work on ios13
      // TODO: detect if on mobile browser an add hidden url bar to height
      // TODO: Add detection of ios rubberband effect
      // TODO: create a lit-html directive for this logic to be reusasble

      const windowHeight = document.documentElement.clientHeight;
      const windowWidth = document.documentElement.clientWidth; // check if the element is in a style.transform context and resize overlay accordingly
      // a transform: translate..(..) will create a new containing block with the bounds of the
      // transformed element as viewport (fixed will then be positioned relative to this new containing block)

      const transformDetectorRect = this.shadowRoot && this.shadowRoot.querySelector('.transformdetector').getBoundingClientRect(); // check if element is somehow in a translated context
      // following must be true to be in a translated context
      // 1. wrapperRect.top must be !== 0:                        if we are in a translated context we have a new containing block so the overlay with style top: 0 is layouted
      //                                                          relative to the element rather than the viewport
      // 2. wrapperRect.left must be !== 0:                       if we are in a translated context we have a new containing block so the overlay with style left: 0 is layouted
      //                                                          relative to the element rather than the viewport
      // 3. wrapperRect.width must be !== windowWidth && !== 0:   usually the wrapper spans the whole viewpoert width with position fixed, if in a translated context
      //                                                          the wrapper spans the width of the elements containing block.
      //                                                          the !== 0 is to detect a false positive => if we are not translated the overlay has a width of 0
      //                                                          in the animationFrame callback because it is not yet layouted, so we have to assume we are not in
      //                                                          a transformed containing block
      // 3. wrapperRect.height must be !== windowHeight && !== 0: usually the wrapper spans the whole viewpoert width with position fixed, if in a translated context
      //                                                          the wrapper spans the width of the elements containing block.
      //                                                          the !== 0 is to detect a false positive => if we are not translated the overlay has a width of 0
      //                                                          in the animationFrame callback because it is not yet layouted, so we have to assume we are not in
      //                                                          a transformed containing block
      // if either one of these 3 expressions are true we have to manually adapt the overlay to the viewport
      // known bugs: transform rotate or scale does not work!

      const isTranslated = transformDetectorRect.top !== 0 || transformDetectorRect.left !== 0 || transformDetectorRect.width !== windowWidth && transformDetectorRect.width !== 0 || transformDetectorRect.height !== windowHeight && transformDetectorRect.height !== 0;
      const overlaywrapper = this.shadowRoot.querySelector('.overlaywrapper');

      if (isTranslated) {
        Object.assign(overlaywrapper.style, {
          left: -transformDetectorRect.left + 'px',
          top: -transformDetectorRect.top + 'px',
          height: windowHeight + 'px',
          width: windowWidth + 'px',
          right: 'auto',
          bottom: 'auto'
        });
      } else {
        Object.assign(overlaywrapper.style, {
          left: null,
          top: null,
          height: null,
          width: null,
          right: null,
          bottom: null
        });
      } // check if below the element is enough space to display. If not, expand dropdown above the element


      const bottomSpace = windowHeight - (top + height);
      const topSpace = top;

      if (bottomSpace > 150 || topSpace < 100) {
        // dropdown under control
        this.listStyle = {
          'top': `${top + height + 4}px`,
          'max-height': Math.min(bottomSpace - 10, 300) + 'px'
        };
      } else {
        // dropdown list over control
        this.listStyle = {
          'bottom': windowHeight - top + (this.label ? 18 : 6) + 'px',
          'max-height': Math.min(topSpace - 10, 300) + 'px'
        };
      }

      const widthField = this.wideList ? 'min-width' : 'width';
      this.listStyle[widthField] = `${width}px`;
      const dropdownWidth = width;
      const listWidth = (_this$shadowRoot$quer = this.shadowRoot.querySelector('.list')) === null || _this$shadowRoot$quer === void 0 ? void 0 : _this$shadowRoot$quer.getBoundingClientRect().width;

      const spaceAround = this._spaceAround.get();

      const alignRight = listWidth > dropdownWidth && spaceAround.right < spaceAround.left && listWidth >= width + spaceAround.right;
      alignRight ? this.listStyle.right = `${spaceAround.right}px` : this.listStyle.left = `${left}px`;
      this.scheduleRender(true);
    });

    this.contentRenderer = defaultContentRenderer;
    this._spaceAround = new ViewportSpaceAround(this);
  }

  componentConnected() {
    this.disabledWatcher(this.disabled, this.disabled);
    this.addEventListener('keydown', this.onKeyCaptureCallback);
    this.addEventListener('mousedown', this.onMouseDown);
  }

  componentDisconnected() {
    this.removeEventListener('keydown', this.onKeyCaptureCallback);
    this.removeEventListener('mousedown', this.onMouseDown);
  }

  componentFirstRender() {
    this.extractDataFromLightDom(null, true);

    this._mutationObserver.observe(this._mutationObeserverParent, {
      attributes: true,
      subtree: true,
      childList: true,
      characterData: true
    });
  }

  render() {
    return html`
    <div class="${classMap({
      icon: !!this.iconSrc,
      container: true,
      expanded: this.expanded,
      placeholder: !this.selectedDataEntry
    })}" @click=${this.onClickCapture}>
      ${this.renderLabel()}
      ${this.renderContainerContent()}
    </div>
    ${this.renderOverlayWrapper()}
    `;
  }

  renderLabel() {
    return html`${this.placeholder || this.selectedDataEntry || this.expanded || this.editable && !!this.value ? html`<label class="label">${this.label}</label>` : html``}`;
  }

  renderContainerContent() {
    return html`
      ${this.renderIcon()}
      ${this.renderInput()}
      ${this.renderExpandIcon()}
    `;
  }

  renderOverlayWrapper() {
    return html`
      <div class="transformdetector"></div>
      <div id="overlaywrapper" @click=${this.onClickCapture} class="${classMap({
      overlaywrapper: true,
      expanded: this.expanded
    })}">
        ${this.renderOptionsList()}
        <slot></slot>
      </div>
    `;
  }

  renderInput() {
    const selectedData = this.selectedDataEntry;
    const internalValue = this.internalValue ? this.internalValue : '';
    const inputValue = selectedData ? selectedData.label ? selectedData.label : selectedData.value : internalValue;
    return html`
    <input class="input"
          .placeholder="${this._getPlaceholder()}"
          type="text"
          .value="${inputValue}"
          @input="${this.onInputInputCallback}"
          @change="${this.onInputChangeCallback}"
          @keydown="${this.onInputKeyDown}"
          title="${this.internalValue ? this.internalValue : ''}"
          ?error="${this.error}"
          ?warning="${this.warning}"
          >
    </input>
    <div class="currentvalue">${selectedData ? this.contentRenderer(selectedData.value, selectedData.label) : this._getPlaceholder()}
    </div>
    <davinci-spinner class="spinner"></davinci-spinner>
    `;
  }

  renderIcon() {
    return this.iconSrc ? html`<davinci-icon-ref class="dropdown-icon" .src=${this.iconSrc}></davinci-icon-ref>` : nothing;
  }

  renderExpandIcon() {
    return html`<davinci-icon-ref class="expand-icon" .src="${this.icon}"></davinci-icon-ref>`;
  }

  _getPlaceholder() {
    return this.placeholder || (!this.expanded ? this.label : '');
  }
  /**
   * Prepares the dataset for more uniformity and easier handling in the render-method.
   * It walks through all array-elements & and the first level of data attributes of DropDownOptions.
   *   1) Converts simple string values into a valid DropDownOption.
   *   2) Sets the selected attribute for DropDownOptions
   *   3) Creates a new object-reference for each DropDownOption(Group)
   *
   * @param data Array<DropDownArrayType>
   * @returns Array<DropDownOption|DropDownOptionGroup>
   */


  getOptionsRenderData(data = []) {
    const prepare = optionData => {
      const value = optionData.value === undefined ? optionData.label : optionData.value;
      return { ...optionData,
        value,
        label: optionData.label,
        content: this.contentRenderer(value, optionData.label),
        selected: optionData.selected || this.internalValue !== undefined && this.internalValue === value
      };
    };

    return data.map(optionData => {
      if (typeof optionData === 'string') {
        return prepare({
          label: optionData
        });
      } else if ('data' in optionData) {
        // OptionGroup
        return { ...optionData,
          data: optionData.data.map(groupChild => {
            return typeof groupChild === 'string' ? prepare({
              label: groupChild
            }) : prepare(groupChild);
          })
        };
      } else {
        return prepare(optionData);
      }
    }).filter(input => 'data' in input || !!input.content); // don't render empty strings -> see [DAVIBE-277]
  }

  renderOptionsList() {
    const optionsList = this.getOptionsRenderData(this.internalData);
    const listClasses = classMap({
      list: true,
      empty: optionsList.length < 1 || !this.internalDataFlat || this.internalDataFlat.length === 0
    });
    return html`
      <div class="${listClasses}" style="${styleMap(this.listStyle)}" @click="${this.stopEventPropagation}">
        ${optionsList.map(option => {
      return 'data' in option ? this.renderOptionGroup(option) : this.renderOption(option);
    })}
      </div>
    `;
  }

  renderOptionGroup(group) {
    return html`
      <davinci-option-group .label=${group.label} @click="${this.onOptionGroupClicked}">
        ${group.data.map(option => this.renderOption(option))}
      </davinci-option-group>
    `;
  }

  renderOption(option) {
    return html`<davinci-option
      @click="${this.onOptionClicked}"
      .value=${option.value}
      .title=${option.title ? option.title : ''}
      ?selected ="${!!option.selected}"
      ?disabled="${!!option.disabled}"
    >
      ${option.content}
    </davinci-option>`;
  }

  componentDidRender() {
    if (!this._listElement) {
      this._listElement = this.shadowRoot.querySelector('.list');
    }
  }

  /**
   * Handles the change-event of the internal input-element
   * @param event
   */
  onInputChange(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this._highlightedOption) {
      this.selectOption(this._highlightedOption);
    } else {
      const inputValue = event.currentTarget.value;
      const oldInternalValue = this.internalValue;
      const selectedData = this.selectedDataEntry; // DAVIBE-564: we may set internalValue to the value of the input-element only if
      // the value of the input is not the same as the label of the selected option.
      // Otherwise we would reset the selection.

      if (selectedData === undefined || selectedData.label !== inputValue) {
        this.internalValue = inputValue;
      }

      if (oldInternalValue !== this.internalValue) {
        this.change.emit(this.internalValue);
      }
    }
  }
  /**
   * Handles the input-event of the internal input-element
   * @param event Event
   */


  onInputInput(event) {
    this.expanded = true;
    event.preventDefault();
    event.stopPropagation();
    this.value = event.currentTarget.value;
    this.input.emit(this.value);
    this.highlightOption();
    this.resetSelectedOption();
  }

  onKeyCapture(event) {
    switch (event.key) {
      case 'ArrowDown':
        this.expandOrMoveHighlight(event, 'down');
        break;

      case 'ArrowUp':
        this.expandOrMoveHighlight(event, 'up');
        break;

      case 'Enter':
        this.selectHighlightedOption(event);
        break;

      case 'Esc':
      case 'Escape':
        event.preventDefault();
        this.expanded = false;
        break;

      case 'Tab':
        this.expanded = false;
        break;

      default:
        return;
    }
  }

  resetSelectedOption() {
    this._getOptions().forEach(option => {
      option.selected = false;
      option.highlighted = false;
    });
  }

  selectHighlightedOption(event) {
    if (this._highlightedOption) {
      event.preventDefault();
      this.selectOption(this._highlightedOption);
    }
  }
  /**
   * Deselect all options, set internalValue, emit change-event and select new option.
   * @param option Option
   */


  selectOption(option) {
    // reset old selection(s)
    for (const optionEl of this._getOptions()) {
      optionEl.selected = false;
    }

    if (this.internalValue !== option.value) {
      this.internalValue = option.value;
      this.change.emit(option.value);
    }

    this.expanded = false;
    option.selected = true;
    this._highlightedOption = null;

    if (this.editable) {
      // Prevent next tab keypress to focus the inner input, instead of the next/previous element.
      this.onFocus();
    }
  }

  editableChanged(_oldValue, _newValue) {
    if (this.editable) {
      this.addEventListener('focus', this._onFocusCallback);
      this.addEventListener('blur', this.onBlur);
    } else {
      this.removeEventListener('focus', this._onFocusCallback);
      this.removeEventListener('blur', this.onBlur);
    }
  }

  disabledWatcher(_oldValue, _newValue) {
    if (this._componentState === COMPONENT_STATE.CONNECTED) {
      this.setAttribute('tabindex', _newValue ? '-1' : '0');
    }
  }

  expandedWatcher(_oldValue, newValue) {
    if (newValue) {
      this._currentAnimationFrame = window.requestAnimationFrame(this._calculateListDimensions);
      window.setTimeout(() => {
        // Add listener for closing on "external" clicks
        // Defer registration to next tick to avoid collision with the bubbled opening click
        window.addEventListener('click', this.clickListener);
        /**
         * Defer listener-registration to next tick, so this.onOptionMouseEnter is not triggered immediately.
         * See {@link onOptionMouseMove} for further information.
         */

        this.addMouseEventListenersToOptions();
      }, 0);
    } else {
      window.cancelAnimationFrame(this._currentAnimationFrame);
      this._currentAnimationFrame = null;
      window.removeEventListener('click', this.clickListener);
      this.removeMouseEventListenersFromOptions();
      this.highlightOption();
    }
  }

  removeMouseEventListenersFromOptions() {
    this._getOptions().forEach(option => {
      option.removeEventListener('mouseenter', this.onOptionMouseEnter);
      option.removeEventListener('mouseleave', this.onOptionMouseLeave);
      option.addEventListener('mousemove', this.onOptionMouseMove);
    });
  }

  addMouseEventListenersToOptions() {
    this._getOptions().forEach(option => {
      option.addEventListener('mouseenter', this.onOptionMouseEnter);
      option.addEventListener('mouseleave', this.onOptionMouseLeave);
      option.addEventListener('mousemove', this.onOptionMouseMove);
    });
  }
  /**
   * @returns NodeListOf<Option> from shadow-dom
   */


  _getOptions() {
    var _this$shadowRoot;

    return ((_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.querySelectorAll('davinci-option')) || [];
  }

  // TODO Document LightDom to ShadowDom synchronization (oneWay)
  // on component connected: check if lightdom is empty (this.children.length) if not? extract and det data
  // on component connected set mutation observer to this and execute extrractDataFromLightDom() everytime, something changes
  // on component disconnected remove mutation observer
  // Check if mutation observer does not debounce multiple changes in one task (analoguous to set data)
  extractDataFromLightDom(mutations, init = true) {
    if (mutations && !init && mutations.filter(value => value.target !== this._mutationObeserverParent || value.target === this._mutationObeserverParent && value.type === 'childList').length === 0) {
      // tslint:disable-line
      return;
    }

    if (init && this.children.length === 0) {
      return;
    }

    if (this.contentRenderer === defaultContentRenderer) {
      // for now use unsafeHTMLRenderer as default for light dom options due to UI Builder contraints DAVIBT-292
      this.contentRenderer = unsafeHTMLRenderer;
    } // tslint:disable-next-line


    const isOptionOrOptionGroup = e => e.tagName.startsWith('DAVINCI-OPTION-GROUP') || e.tagName.startsWith('DAVINCI-OPTION') || e.tagName === 'OPTION' || e.tagName === 'OPTGROUP';

    const isGroup = e => e.tagName.startsWith('DAVINCI-OPTION-GROUP') || e.tagName === 'OPTGROUP';

    const isOption = e => e.tagName.startsWith('DAVINCI-OPTION') || e.tagName === 'OPTION';

    this.data = Array.from(this.children).filter(isOptionOrOptionGroup).map(dataPoint => {
      if (isGroup(dataPoint)) {
        return {
          label: dataPoint.label,
          data: Array.from(dataPoint.children).filter(isOption).map(option => {
            return this._buildDropDownOptionFor(option);
          })
        };
      } else {
        // is Option
        return this._buildDropDownOptionFor(dataPoint);
      }
    });
  }

  _buildDropDownOptionFor(option) {
    var _option$value;

    return {
      label: option.innerHTML.trim() || option.value,
      value: (_option$value = option.value) !== null && _option$value !== void 0 ? _option$value : option.innerHTML.trim(),
      selected: option.selected,
      disabled: option.disabled,
      title: option.title
    };
  }

  _scrollElementIntoView(scrollable) {
    const boundingRect = scrollable.getBoundingClientRect();

    const listRect = this._listElement.getBoundingClientRect();

    const top = listRect.top;
    const bottom = listRect.top + listRect.height;

    if (boundingRect.top < top || boundingRect.top + boundingRect.height > bottom) {
      // if element out of view
      this._listElement.scrollTop = this._listElement.scrollTop + (boundingRect.top + boundingRect.height - bottom);
    }
  }

  moveHighlight(direction) {
    if (direction === 'up') {
      if (!this._highlightedOption) {
        const children = this.shadowRoot.querySelector('.list').children; // get list of Options

        this.highlightElement(children[children.length - 1], direction);
      } else if (this._highlightedOption.previousElementSibling) {
        this.highlightElement(this._highlightedOption.previousElementSibling, direction);
      } else if (this._highlightedOption.parentElement instanceof OptionGroup && this._highlightedOption.parentElement.previousElementSibling) {
        this.highlightElement(this._highlightedOption.parentElement.previousElementSibling, direction);
      }
    } else {
      if (!this._highlightedOption) {
        this.highlightElement(this.shadowRoot.querySelector('.list').children[0], direction);
      } else if (this._highlightedOption.nextElementSibling) {
        this.highlightElement(this._highlightedOption.nextElementSibling, direction);
      } else if (this._highlightedOption.parentElement instanceof OptionGroup && this._highlightedOption.parentElement.nextElementSibling) {
        this.highlightElement(this._highlightedOption.parentElement.nextElementSibling, direction);
      }
    }
  }
  /**
   * Sets the selection cursor (highlighting of an Option) on a specific element
   * If a direction is passed and the element parameter is an OptionGroup,
   * the selection cursor is set to the previous/next Option
   */


  highlightElement(element, direction) {
    if (!element) {
      return;
    }

    if (element instanceof Option && !element.disabled) {
      this.highlightOption(element);

      this._scrollElementIntoView(this._highlightedOption);
    } else {
      // behavior if the element is not an instance of Option or disabled
      if (direction === 'up') {
        if (element instanceof OptionGroup && element.children.length > 0) {
          // if element is a non-empty OptionGroup
          this.highlightElement(element.lastElementChild, direction);
        } else if (element.previousElementSibling) {
          this.highlightElement(element.previousElementSibling, direction);
        } else if (element.parentElement.previousElementSibling) {
          // DAVIBE-593: cursor down doesn't work for options-group with disabled options
          this.highlightElement(element.parentElement.previousElementSibling, direction);
        }
      } else if (direction === 'down') {
        if (element instanceof OptionGroup && element.children.length > 0) {
          this.highlightElement(element.firstElementChild, direction);
        } else if (element.nextElementSibling) {
          this.highlightElement(element.nextElementSibling, direction);
        } else if (element.parentElement.nextElementSibling) {
          // DAVIBE-593: cursor down doesn't work for options-group with disabled options
          this.highlightElement(element.parentElement.nextElementSibling, direction);
        }
      }
    }
  }

  highlightOption(option) {
    if (this._highlightedOption) {
      // reset old highlight
      this._highlightedOption.highlighted = false;
      this._highlightedOption = null;
    }

    if (option) {
      // set new highlight
      this._highlightedOption = option;
      this._highlightedOption.highlighted = true;
    }
  }

  _getSelectedOption() {
    return this.shadowRoot.querySelector('davinci-option[selected]');
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec3, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "placeholder", [_dec5, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "editable", [_dec7, _dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec9, _dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "loading", [_dec11, _dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "label", [_dec13, _dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "iconSrc", [_dec15, _dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "error", [_dec17, _dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "warning", [_dec19, _dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "wideList", [_dec21, _dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "data", [_dec23, _dec24], Object.getOwnPropertyDescriptor(_class2.prototype, "data"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "value", [_dec25, _dec26], Object.getOwnPropertyDescriptor(_class2.prototype, "value"), _class2.prototype), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "expanded", [_dec27, _dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "contentRenderer", [_dec29, _dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "showPlaceholder", [_dec31, _dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec33, _dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, "input", [_dec35, _dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "editableChanged", [_dec37, _dec38], Object.getOwnPropertyDescriptor(_class2.prototype, "editableChanged"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "disabledWatcher", [_dec39, _dec40], Object.getOwnPropertyDescriptor(_class2.prototype, "disabledWatcher"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "expandedWatcher", [_dec41, _dec42], Object.getOwnPropertyDescriptor(_class2.prototype, "expandedWatcher"), _class2.prototype)), _class2)) || _class) || _class);
